import React from 'react';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import tachinhu from './image/booking/tachinhu.png';
// Dữ liệu lịch trình chuyến đi Tà Chì Nhù
const taChiNhuSchedule = [
  {
    day: "Chiều Thứ 6",
    activities: [
      { time: "06:30 PM", description: "Xe khởi hành từ Hà Nội, bắt đầu hành trình tìm về miền mây trắng." },
      { time: "11:30 PM", description: "Có mặt và nhận phòng nghỉ tại homestay Trạm Tấu - Yên Bái" },
      { 
        description: "Tạm gác lại những ồn ào phố thị, hãy để bản thân được vỗ về bởi không khí se lạnh của vùng cao. Một giấc ngủ sâu tối nay là bước chuẩn bị hoàn hảo nhất để bạn rạng rỡ và tràn đầy sức sống cho ngày mai." 
      }
    ],
  },
  {
    day: "Thứ 7 - Hành Trình Xuyên Mây",
    activities: [
      { time: "06:30 AM", description: "Ăn sáng dinh dưỡng tại homestay, nạp năng lượng cho ngày dài" },
      { 
        description: "Bữa sáng đầy đủ tinh bột và đạm là bí quyết để đôi chân bạn bền bỉ hơn. Đội ngũ hướng dẫn sẽ giúp bạn sắp xếp hành lý, những đồ dùng chưa cần đến hãy cứ gửi lại homestay để hành trình thêm nhẹ nhàng nhé." 
      },
      { time: "07:30 AM", description: "Trải nghiệm xe ôm bản địa xuyên qua những đồi dốc hùng vĩ" },
      { 
        description: "Đây là lúc bạn cảm nhận được sự tự do thực sự khi gió núi luồn qua tóc. Hãy cứ thoải mái dừng lại ở một góc cua đẹp, chụp lấy tấm ảnh ưng ý để thấy rằng thanh xuân này là để dành cho những cung đường." 
      },
      { time: "08:30 AM", description: "Đến điểm leo - Bắt đầu viết nên câu chuyện chinh phục của riêng bạn" },
      { 
        description: "Dưới sự hỗ trợ tận tình của các Porter, chúng ta sẽ bắt đầu những bước chân đầu tiên. Đừng lo lắng, chúng mình đã chuẩn bị sẵn nước uống, áo mưa và găng tay để chăm sóc bạn chu đáo nhất." 
      },
      { time: "11:30 AM", description: "Dừng chân dùng bữa trưa picnic giữa đại ngàn" },
      { 
        description: "Giữa tiếng gió và mây ngàn, một bữa trưa giản đơn cũng trở nên đậm đà lạ thường. Hãy nhắm mắt nghỉ ngơi 15 phút, để tâm hồn được thư thái trước khi tiếp tục hành trình." 
      },
      { time: "04:30 PM", description: "Cán đích lán nghỉ dừng chân" },
      { 
        description: "Lán nghỉ Tà Chì Nhù là nơi tách biệt hoàn toàn với thế giới bên ngoài. Trong cái lạnh của đỉnh cao, hơi ấm từ bếp lửa và chăn đệm đã sẵn sàng để vỗ về bạn sau một ngày nỗ lực." 
      },
    ],
  },
  {
    day: "Chủ Nhật - Bình Minh Trên Biển Mây",
    activities: [
      { time: "03:30 AM", description: "Thức dậy, đón những tia nắng đầu tiên trong sương sớm" },
      { 
        description: "Ở độ cao gần 3.000m, hãy giữ ấm cơ thể và dùng một bữa sáng nhẹ nhàng. Hành trình chạm đỉnh lúc bình minh đang chờ đón bạn với những điều kỳ diệu nhất." 
      },
      { time: "04:30 AM", description: "Bắt đầu chặng cuối chinh phục đỉnh núi" },
      { 
        description: "Đoạn đường này dốc và thoáng đạt, nơi bạn sẽ thấy biển mây dần hiện ra dưới chân mình. Hãy đi thật vững chãi, chúng mình luôn ở ngay sát bên cạnh để hỗ trợ bạn." 
      },
      { time: "06:30 AM", description: "Chạm đỉnh Tà Chì Nhù (2.979m) - Khoảnh khắc vinh quang" },
      { 
        description: "Chúc mừng bạn! Giữa biển mây bồng bềnh và sắc hoa Chi Pâu tím biếc (theo mùa), bạn chính là người rạng rỡ nhất. Hãy lưu lại những khung hình đẹp nhất cho chuyến đi để đời này nhé." 
      },
      { time: "09:00 AM", description: "Thu dọn hành lý tại lán và bắt đầu xuống núi" },
      { 
        description: "Sự an toàn của bạn là ưu tiên số một. Hãy kiểm tra kỹ dây giày và đừng ngần ngại chia sẻ với Porter nếu bạn cảm thấy mỏi chân, chúng mình sẽ giúp bạn xuống núi một cách nhẹ nhàng nhất." 
      },
      { time: "12:00 PM", description: "Dùng bữa trưa giữa rừng và nghỉ ngơi" },
      { time: "04:00 PM", description: "Về tới chân núi, xe ôm đưa đoàn về thiên đường thư giãn" },
      { time: "04:30 PM", description: "Ngâm mình trong suối khoáng nóng Trạm Tấu" },
      { 
        description: "Sau bao nỗ lực, hãy để làn nước khoáng nóng tự nhiên chăm sóc cơ thể bạn. Cảm giác các thớ cơ được thả lỏng hoàn toàn và làn da được vỗ về bởi khoáng chất sẽ khiến bạn sảng khoái đến tận cùng." 
      },
      { time: "06:00 PM", description: "Bữa tối liên hoan với đặc sản gà đen và cá suối Trạm Tấu" },
      { 
        description: "Thưởng thức lẩu gà đen thơm phức hay cá nướng Ba Bỉnh Tộp trong niềm vui chiến thắng. Những món ăn đậm đà này là lời cảm ơn ngọt ngào nhất dành cho nỗ lực của bạn." 
      },
      { time: "07:30 PM", description: "Lên xe khởi hành về lại Hà Nội" },
      { time: "11:30 PM", description: "Về tới Hà Nội. Kết thúc hành trình an toàn và đầy cảm hứng." }
    ],
  },
];

const TaChiNhuSchedule = () => {
  const exportPDF = () => {
    const input = document.getElementById("schedule");
    html2canvas(input, { scale: 1.5 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.7); // 0.7 = chất lượng nén
      const imgWidth = 210;
      const pageHeight = (canvas.height * imgWidth) / canvas.width;

      const pdf = new jsPDF("p", "mm", [imgWidth, pageHeight]);
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, pageHeight, null, "FAST");
      pdf.save("lich-trinh-ta-chi-nhu.pdf");
    });
  };


  return (
    <div>
    <div id="schedule" className="schedule-container" style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <div  className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
        <p className='block text-lg font-sans italic px-5 py-2'>
          Tà Chì Nhù – ngọn núi cao thứ 7 Việt Nam, không chỉ là một đỉnh cao để chinh phục, mà còn là “Thang Mây” huyền thoại,
           nơi bạn sẽ bước lên trên biển mây bồng bềnh và ngắm nhìn Bình Minh Rực Lửa từ độ cao gần 3.000 mét.
        </p>
        <p  className='block text-lg font-italic font-sans italic px-5 py-2'>
          Ảnh: Hoàng hôn núi Tà Chì Nhù
        </p>
        <img src={tachinhu} alt="" className="w-96 bg-white shadow-md border-4 border-white p-5 rounded-lg w-11/12" />
      </div>
        <h2 className ='text-5xl' style={{ color: '#387338', borderBottom: '2px solid #a8c6a8', paddingBottom: '10px' }}>
          Chi tiết
        </h2>
      {taChiNhuSchedule.map((dayData, index) => (
        <div key={index} className="day-schedule" style={{ marginBottom: '30px', borderLeft: '3px solid #6b8e23', paddingLeft: '15px' }}>
          <h3 style={{ color: '#6b8e23', backgroundColor: '#f0fff0', padding: '5px 10px', borderRadius: '4px' }}>
            {dayData.day}
          </h3>
          <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
            {dayData.activities.map((activity, idx) => (
              <li key={idx} className="activity-item text-lg font-sans " style={{ marginBottom: '15px', display: 'flex' }}>
                <strong style={{ minWidth: '85px', color: '#333' }}>
                  {activity.time}
                </strong>
                <span style={{ flexGrow: 1, paddingLeft: '10px' }}>
                  {activity.description}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <button 
        onClick={exportPDF}
        className=" m-5 px-5 py-2 bg-green-600 text-white px-4 py-2 rounded-md mb-4"
      >
        Xuất PDF
    </button>
  </div>
  );
};

export default TaChiNhuSchedule;